import {
  glyphIconStyle,
  helpbuttonStyle,
  inputFieldStyle,
  buttonInputStyle,
  uiblockerStyle,
  linkStyle,
  convertToLocalStyle,
  truncatedStyle,
} from '@bingads-webui-campaign-react/common-styles';

export const getSetupPageStyes = (_, { palette = {} }) => ({
  setupPage: {
    margin: '20px 32px',

    '& .alert': {
      fontSize: 14,
    },

    '& .error': {
      color: palette.redDark,
    },

    '& ul[role=alert]': {
      listStyle: 'none',
      paddingLeft: 0,
    },

    '& .inactive': {
      color: palette.neutralTertiary,
    },

    '& .header': {
      '& h1': {
        fontSize: 20,
        fontWeight: 600,
        lineHeight: '27px',
        marginTop: 0,
      },
      '& h3': {
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '20px',
      },
    },

    '& nav.hotel-center-navbar': {
      margin: '20px -32px 10px -32px',
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
      background: 'none',
      '& ul.nav.navbar-nav': {
        fontSize: 18,
        lineHeight: '44px',
        marginLeft: 32,
        '& li.active a': {
          background: 'none',
          color: palette.neutralPrimary,
          fontWeight: 600,
          fontSize: 18,
          borderBottom: `2px solid ${palette.themePrimary}`,
          height: 'fit-content',
          cursor: 'default',
        },
        '& li.normal a': {
          color: palette.neutralSecondary,
          cursor: 'default',
        },
      },
    },

    '& .account-name-panel': {
      '& .form-group': {
        marginBottom: 8,
      },
      '& .input-group': {
        marginBottom: 15,
      },
    },

    '& .button-panel': {
      '& .btn-primary': {
        marginRight: 10,
      },
    },

    '& .budget-bid-panel': {
      width: 800,

      '& .info-header': {
        marginBottom: 20,

        '& .col-sm-1': {
          minWidth: 150,
        },
        '& h3': {
          fontSize: 14,
          fontWeight: 400,
          margin: '10px 0px',
        },
        '& .type-bold': {
          fontWeight: 600,
        },
      },

      '& .budget-bid-setting': {
        '& .col-sm-2, .col-sm-3': {
          width: '100%',
        },
        '& .control-label': {
          textAlign: 'left',
          '& label': {
            display: 'inline',
          },
        },
        '& .input-control': {
          width: 400,
          marginTop: 5,
        },
        '& .input-group-addon': {
          border: 'none',
          background: 'none',
          color: palette.neutralPrimary,
        },
        '& .form-group': {
          marginBottom: 10,
        },
        '& .radio input[type="radio"]': {
          marginLeft: 0,
        },
        '& .bid-strategy-panel': {
          marginLeft: -20,
          '& label': {
            fontWeight: 400,
          },
        },
      },

      '& .bid-selection': {
        '& .col-sm-12': {
          margin: 0,
        },
        '& .radio label': {
          padding: 0,
          marginLeft: -8,
        },
        '& .col-sm-7.show': {
          paddingLeft: 0,
          marginLeft: -15,
        },
      },
    },

    '& .save-and-go-next-btn[disabled]': {
      cursor: 'not-allowed',
      background: '#f3f2f1',
      borderColor: 'transparent',
      color: '#a19f9d',
    },

    ...convertToLocalStyle(glyphIconStyle({ palette })),
    ...convertToLocalStyle(helpbuttonStyle({ palette })),
    ...convertToLocalStyle(inputFieldStyle({ palette })),
    ...buttonInputStyle({ palette }),
    ...linkStyle,
    ...truncatedStyle,
  },
  '@global': {
    '.bingads-campaign-react-sub-page-menu .compared-date-range-picker': {
      display: 'none',
    },
    ...uiblockerStyle({ palette }),
  },
});
